import { createApiActions } from '../../../utils/api-state';
import { CustomerAttributesState } from '../models/customer-attributes.model';
import { UpdateStatedIncomeReq, StatedIncomeData } from '../../profile/models/income.model';

export const customerAttributesActions = createApiActions<any, CustomerAttributesState>('[CAS] Get Attributes');
// profile data
export const getUpdateStatedIncomeActions = createApiActions<UpdateStatedIncomeReq, StatedIncomeData>(
  '[Profile] Update Stated Income'
);
